import { combineReducers } from 'redux';
import { SLAVE_AVAILABLE } from './constants';
import messages from './messages/reducer';

const initialFeaturesState = {
  supportsCart: false,
  nonBlockingHandoff: false,
};

// eslint-disable-next-line default-param-last
const features = (state = initialFeaturesState, action) => {
  switch (action.type) {
    case SLAVE_AVAILABLE:
      return action.payload.features || initialFeaturesState;
    default:
      return state;
  }
};

export default combineReducers({
  features,
  messages,
});
